export default __webpack_public_path__ + "static/media/simbolo-primary.ed70d0d1.png";